import React, { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Select, Option, Button } from '@sololearnorg/sol';
import { Container, i18n } from '../../../../symphony';

import { ActionType, RequestType } from '../../global-interface';
import { RepliesOrderType, SlDiscussContext } from '../../global-constants';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { SlDataService } from '../../services/sl-data.service';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';

import s from './RepliesFilter.scss';

export function RepliesFilter() {
	useStyles(s);
	const repliesFilterRef = useRef<HTMLDivElement>(null);
	const [searchParams, setSearchParams] = useSearchParams();
	const currentPageNumber = +searchParams.get('page') || 1;
	const { actions$ } = Container.take(SlDiscussContext, SlActions);
	const { question$: question } = useContainerData(
		SlDiscussContext,
		SlDataService,
		['question$'],
	);

	const answerClickHandler = () => {
		actions$.next({
			type: ActionType.OnAnswerButtonClick,
			requestType: RequestType.Parallel,
		});
	};

	const sortChangeHandler = (sortType: number) => {
		setSearchParams({
			page: '1',
			sort: sortType.toString(),
		});
	};

	useEffect(() => {
		if (searchParams.get('page')) {
			repliesFilterRef.current?.scrollIntoView({
				behavior: 'auto',
				block: 'center',
			});
		}
	}, [currentPageNumber]);

	return question ? (
		<div className="discuss-replies-filter" ref={repliesFilterRef}>
			<div className="discuss-replies-filter__replies-count">
				{i18n.t('web-discuss.answers-count', {
					count: question.answers,
				})}
			</div>
			{question.answers > 1 && (
				<Select
					name="sort"
					size="s"
					defaultValue={
						+searchParams.get('sort') || RepliesOrderType.Vote
					}
					className="discuss-replies-filter__sort"
					onValueChange={sortChangeHandler}
				>
					<Option value={RepliesOrderType.Vote}>
						{i18n.t('web-discuss.answers-sort-by-votes')}
					</Option>
					<Option value={RepliesOrderType.Date}>
						{i18n.t('web-discuss.answers-sort-by-date')}
					</Option>
				</Select>
			)}
			<Button size="s" onClick={answerClickHandler}>
				{i18n.t('web-discuss.answer-button')}
			</Button>
		</div>
	) : null;
}
